import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux'
import AreaElement from './AreaElement.react';
import { DragDropContext, DropTarget } from 'react-dnd';
import update from 'react/lib/update';
import * as DocumentStorageActions from '../../actions/documentStorage'
import flow from 'lodash/flow';
import HtmlToReact from 'html-to-react';
import UploadImage from './UploadImage.react';
import { FormattedMessage } from 'react-intl';

class Area extends React.Component {

    static get defaultProps() {
        return {
            ConfiguratorManager: {},
            area: null,
            canDrop: null,
        }
    }

    constructor(props) {
        super(props);
        this.moveAreaElement = this.moveAreaElement.bind(this);
        this.addAreaElement = this.addAreaElement.bind(this);
        this.removeAreaElement = this.removeAreaElement.bind(this);
        this.editField = this.editField.bind(this);

        const {area, ConfiguratorManager } = props;

        this.state = {
            areaElements: ConfiguratorManager.getAreaDndElements(area.id),
        };
    }

    moveAreaElement(dragIndex, hoverIndex) {

        const {areaElements} = this.state;
        const dragAreaElement = areaElements[dragIndex];

        this.setState(update(this.state, { // @see https://facebook.github.io/react/docs/update.html
            areaElements: {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, dragAreaElement]
                ]
            }
        }), function() {
            this.updateStorageData();
        });
    }

    editField(elementIndex, key, value) {

        const {areaElements} = this.state;

        // get element to update by given index
        let elementToUpdate = null;
        areaElements.map(function (element, index) {
            if (index === elementIndex) {
                elementToUpdate = element;
            }
        });

        const newElement = update(elementToUpdate, {data: {documentStorage: {$merge: {[key]: value}}}});

        let newElements = [];
        areaElements.map(function (element, index) {
            if (index === elementIndex) {
                newElements.push(newElement);
            } else {
                newElements.push(Object.assign({}, element));
            }
        });

        const newState = {
            areaElements: newElements
        };

        this.setState(newState, function () {
            this.updateStorageData();
        });
    }

    addAreaElement(contentElementData, areaElementTemplate) {

        const { user, ConfiguratorManager} = this.props;

        const userId = (user && user.userId) ? user.userId : null;

        const newElement = {
            ref: {
                contentElement: contentElementData.id,
                areaData: null,
            },
            data: {
                contentElement: contentElementData,
                document: null,
                documentStorage: {}
            },
            createdBy: userId,
        };

        this.setState(update(this.state, {
                areaElements: {
                    $push: [newElement]
                }
            }),
            function() {
                this.updateStorageData()
            }
        );
    }

    removeAreaElement(index) {
        this.setState(update(this.state, {
                areaElements: {
                    $splice: [
                        [index, 1]
                    ]
                }
            }),
            function() {
                this.updateStorageData()
            }
        );
    }

    updateStorageData() {
        let {dispatch, area, ConfiguratorManager} = this.props;

        const updatedStorage = ConfiguratorManager.updateStorageData(area.id, this.state.areaElements);

        dispatch(DocumentStorageActions.updateDocumentStorage(
            ConfiguratorManager.getStorageId(), null, null, updatedStorage)
        );
    }

    render() {

        const {area, connectDropTarget, canDrop, isOver, getItem, user, ConfiguratorManager, app} = this.props;
        const layoutElement = ConfiguratorManager.getLayoutElement(area);
        const {areaElements} = this.state;
        const appConfig = app.config;
        const countAreaElements = areaElements.length;
        const isDraggable = area.draggable ? area.draggable : false;
        let dropStyle;

        let className = 'configurator-area configurator-area-element-count-' + countAreaElements;
        const idName = 'configurator-area-' + area.id;

        if (isOver && getItem.source === 'contentElement') {
            if (canDrop) {
                dropStyle = 'area-drop-allowed';
            } else {
                dropStyle = 'area-drop-disallowed';
            }
        }

        if (isDraggable) {
            className += ' configurator-area-dropable';
        }

        let areaContent = null;

        // static layouts render direct, without data
        if (area.staticLayout) {
            areaContent = this._getStaticAreaContent(
                idName, className, layoutElement, connectDropTarget, ConfiguratorManager, area
            );
        } else if (layoutElement && layoutElement.table) {
            areaContent = this._getTableAreaContent(
                idName, className, layoutElement, area, ConfiguratorManager, areaElements, connectDropTarget,
                user, appConfig
            )
        } else {
            areaContent = this._getAreaContent(
                idName, className, layoutElement, area, ConfiguratorManager, areaElements, connectDropTarget,
                user, appConfig, countAreaElements, dropStyle
            );
        }

        return areaContent
    }

    _getTableAreaContent(idName, className, layoutElement, area, ConfiguratorManager, areaElements, connectDropTarget,
                         sessionUser, appConfig) {

        const headerRows = layoutElement.table && layoutElement.table.header ? layoutElement.table.header : [];
        const bodyRows = layoutElement.table && layoutElement.table.body ? layoutElement.table.body : [];

        // build html for table row
        let layoutElementRow = '';
        bodyRows.map(function(row) {
            layoutElementRow += '<div class="area-table-cell">' + row + '</div>';
        });

        const dropTarget =  areaElements.map((dataEntry, i) => {
                    return (
                        <AreaElement key={i}
                                     index={i}
                                     id={area.id}
                                     editField={this.editField}
                                     moveAreaElement={this.moveAreaElement}
                                     removeAreaElement={this.removeAreaElement}
                                     areaElement={dataEntry}
                                     layoutElement={layoutElementRow}
                                     area={area}
                                     ConfiguratorManager={ConfiguratorManager}
                                     isTable={true}
                                     sessionUser={sessionUser}
                                     appConfig={appConfig} />
                    );
                });

        const areaMarkup = <div id={idName} className={className}>
            <div className="area-table">
                <div className="area-table-row area-table-head">
                {
                    headerRows.map(function(row, i) {
                        return <div className="area-table-cell" key={i}>{row}</div>
                    })
                }
                </div>
                { dropTarget }
            </div>
        </div>;

        return connectDropTarget(areaMarkup);

    }

    _getStaticAreaContent(idName, className, layoutElement, connectDropTarget, ConfiguratorManager, area) {

        const html = '<div class="configurator-area-element">' + layoutElement + '</div>';

        var isValidNode = function() {
            return true;
        };
        var processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
        var processingInstructions = [
            {
                // Processing editable fields
                shouldProcessNode: function(node) {
                    return (this.isUploadImage(node)) ? true : false;
                },

                // Replaced predpared nodes by components
                processNode: function(node, children) {
                    if (this.isUploadImage(node)) {
                        return this.processUploadImage(node);
                    }
                },

                processUploadImage(node) {
                    return <UploadImage
                        uploadSettingRef={ node.attribs.uploadsettingref }
                        uploadWidgetId={ node.attribs.uploadwidgetid }
                        ConfiguratorManager={ConfiguratorManager}
                        areaId={area.id} />
                },

                isUploadImage(node) {
                    return node.name === 'uploadimage'
                }
            },
            {
                // Processing root node
                shouldProcessNode: function(node) {
                    return node.type && node.type === 'tag' && node.name && node.name === 'div' && node.attribs &&
                        node.attribs.class && node.attribs.class === 'configurator-area-element';
                },

                processNode: function(node, children) {
                    let className = 'configurator-area-element';
                    return <div className={className}>
                        { children }
                    </div>;
                }
            },
            {
                // Anything else
                shouldProcessNode: function(node) {
                    return true;
                },
                processNode: processNodeDefinitions.processDefaultNode
            }];

        const htmlToReactParser = new HtmlToReact.Parser(React);
        const parsedElement = htmlToReactParser.parseWithInstructions(html, isValidNode, processingInstructions);

        const areaContent = <div id={idName} className={className}>
            {parsedElement}
        </div>

        return connectDropTarget(areaContent);
    }

    _getAreaContent(idName, className, layoutElement, area, ConfiguratorManager, areaElements, connectDropTarget,
                    sessionUser, appConfig, countAreaElements, dropStyle) {

        const contentType = (area.contentElementDataCriteria && area.contentElementDataCriteria.type) ? area.contentElementDataCriteria.type : false;
        let dropMessageElement = null;
        // If area is empty, show drop message
        if(countAreaElements === 0) {
            let dropMessageElementCssName = 'configurator-element-area-box';
            let dropMessage = <div className="drop-message"><FormattedMessage id="TEXT_AREA_DROP_MESSAGE"/></div>;

            if (dropStyle) {
                dropMessage = <div className="drop-image"></div>;
                dropMessageElementCssName += ' ' + dropStyle;
            } else if (area.dropMessage) {
                dropMessage = <div className="drop-message"><span>{area.dropMessage}</span></div>;
            }

            dropMessageElement = <div className={dropMessageElementCssName}>{dropMessage}</div>;

        }
        // Very exclusive case for 'beer-mix-beverages' -> content related Code!
        // TODO: Find a more generic solution for this special case, e.g. Admin Flag
        else if ((Object.values(contentType).indexOf('beerMix') > 0) && countAreaElements <= 2 && countAreaElements > 0) {
            let dropMessageElementCssName = 'configurator-element-area-box-beer-mix';
            let dropMessage = null;

            className = 'configurator-area configurator-area-element-count-0 configurator-area-dropable';

            if (dropStyle) {
                dropMessage = <div className="drop-image"></div>;
                dropMessageElementCssName += ' ' + dropStyle;
            }

            dropMessageElement = <div className={dropMessageElementCssName}>{dropMessage}</div>;
        }

        const areaContent = <div id={idName} className={className}>
            {
                areaElements.map((dataEntry, i) => {
                    return (
                        <AreaElement key={i}
                                     index={i}
                                     id={area.id}
                                     editField={this.editField}
                                     moveAreaElement={this.moveAreaElement}
                                     removeAreaElement={this.removeAreaElement}
                                     areaElement={dataEntry}
                                     layoutElement={layoutElement}
                                     area={area}
                                     ConfiguratorManager={ConfiguratorManager}
                                     sessionUser={sessionUser}
                                     appConfig={appConfig}
                        />
                    );
                })
            }
            { dropMessageElement }
        </div>;

        return connectDropTarget(areaContent);
    }
}

const areaTarget = {

    canDrop(props, monitor) {

        const isDraggable = props.area.draggable ? props.area.draggable : false;
        const maxElements =  props.area.maxElements ? props.area.maxElements : 100; // TODO ... default value from config
        const item = monitor.getItem();
        const staticLayout = props.area.staticLayout ? props.area.staticLayout : false;
        const countElements = props.ConfiguratorManager.getAreaDndElements(props.area.id).length;
        const contentElementDataCriteria = props.area.contentElementDataCriteria ? props.area.contentElementDataCriteria : false;

        let retVal = true;

        if (item.source === 'contentElement') {

            // check if defined contentElement criteria match by contentElementData
            let criteriaAllowed = true;
            if (contentElementDataCriteria && Object.keys(contentElementDataCriteria).length > 0) {

                Object.keys(contentElementDataCriteria).map(criteriaKey => {

                    let criteriaValues = contentElementDataCriteria[criteriaKey];

                    // check if criteria key exits in itemData
                    if (!item.data.hasOwnProperty(criteriaKey)) {
                        criteriaAllowed = false;
                    }

                    // if criteriaValue not defined as array, initialize as array
                    if ((criteriaValues instanceof Array) === false) {
                        criteriaValues = new Array(criteriaValues);
                    };

                    let valuesAllowed = false;
                    // compare each value with item data, if at least one match the criteria is allowed
                    criteriaValues.map((criteriaValue) => {
                        if (item.data[criteriaKey] &&
                            (item.data[criteriaKey].toLowerCase() === criteriaValue.toLowerCase())) {
                            valuesAllowed = true;
                        }
                    });

                   if (valuesAllowed === false) {
                       criteriaAllowed = false;
                   }
                });
            }

            if (!isDraggable || (maxElements <= countElements) || criteriaAllowed === false) {
                retVal = false;
            }

        }

        if (staticLayout) { // static layouts not draggable
            retVal = false;
        }

        return retVal;
    },

    drop(props, monitor, component ) {
        const item = monitor.getItem();
        if (item.source === 'contentElement') {
            component.addAreaElement(monitor.getItem().data, props.area.element.layout.configurator);
        }
    },

    hover(props, monitor, component) {
    }
};

function collect(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDropTarget: connect.dropTarget(),
        // You can ask the monitor about the current drag state:
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType(),
        getItem: monitor.getItem()
    };
}

export default flow (
    DropTarget("CONFIGURATOR_DND", areaTarget, collect),
    connect(state => ({ app: state.app, configurator: state.configurator, documentStorage: state.documentStorage, user: state.user }))
)(Area);


// WEBPACK FOOTER //
// ./src/js/components/configuratorElements/Area.react.jsx